// extracted by mini-css-extract-plugin
module.exports = {"post":"post--V6DMY","carouselContainer":"carouselContainer--Lb8lM","carousel":"carousel--7v0pS","slideHidden":"slideHidden--aHbPa","postArrows":"postArrows--nd5Nf"};